import React, { useEffect, useState } from 'react';

/**
 * Types `text` one character at a time, then leaves a blinking cursor.
 * Supports multi-line text by splitting on \n.
 */
const TypingText = ({
  text,
  speed = 75,
  startDelay = 250,
  cursor = '_',
  className = '',
  cursorClassName = '',
  onDone,
}) => {
  const [shown, setShown] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    let i = 0;
    let timer;

    const startTimer = setTimeout(() => {
      timer = setInterval(() => {
        i += 1;
        setShown(text.slice(0, i));
        if (i >= text.length) {
          clearInterval(timer);
          setDone(true);
          if (onDone) onDone();
        }
      }, speed);
    }, startDelay);

    return () => {
      clearTimeout(startTimer);
      clearInterval(timer);
    };
  }, [text, speed, startDelay, onDone]);

  const lines = shown.split('\n');

  return (
    <span className={className}>
      {lines.map((line, idx) => (
        <React.Fragment key={idx}>
          {line}
          {idx === lines.length - 1 && (
            <span
              className={`inline-block ${done ? 'animate-pulse' : ''} ${cursorClassName}`}
              aria-hidden
            >
              {cursor}
            </span>
          )}
          {idx < lines.length - 1 && <br />}
        </React.Fragment>
      ))}
    </span>
  );
};

export default TypingText;
